import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fmt = (amount, currency) => {
  const n = Number(amount || 0);
  if (currency === "EUR") return `${n.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 })} PC`;
  return `${Math.round(n).toLocaleString("hu-HU")} GC`;
};

export default API;
